<template>
  <section class="how-it-works-section">
    <div class="container">
      <div class="left-column">
        <h1 class="left-column-title">How it works</h1>
        <p class="left-column-description">
          Four simple steps. For a brighter future.
        </p>
        <ApplyButton
          cta-section="how-it-works"
          page-name="role-page"
          class="proxify-btn proxify-btn-white"
        />
      </div>
      <div class="right-column">
        <div class="items">
          <div
            v-for="(item, index) in items"
            :key="index"
            class="item"
          >
            <NuxtImg
              class="item-icon"
              :src="item.icon"
              alt="item"
            />
            <NuxtImg
              v-if="index === 0"
              class="line"
              alt="line"
              src="/images/roles/how-it-works/line.svg"
            />
            <NuxtImg
              v-if="[1, 2].includes(index)"
              class="line"
              alt="line"
              src="/images/roles/how-it-works/dotted_line.svg"
            />
            <div class="content">
              <h2>{{ item.title }}</h2>
              <p>{{ item.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ApplyButton from '~/components/Common/ApplyButton/ApplyButton.vue';

export default {
  components: {
    ApplyButton,
  },
  data() {
    return {
      items: [
        {
          title: 'Apply now',
          description:
            'Complete our online application form, it should only take a few minutes.',
          icon: '/images/roles/how-it-works/apply_now.svg',
        },
        {
          title: 'Complete vetting process',
          description:
            'Our proprietary vetting process includes a technical test, and an interview with our friendly assessment team. This allows us to evaluate your talents, and understand your specific capabilities.',
          icon: '/images/roles/how-it-works/vetting_process.svg',
        },
        {
          title: 'Join our network',
          description:
            'As a member, you’ll gain access to career coaching, webinars in your field, and an all-in-one platform for payments, time management, and job openings.',
          icon: '/images/roles/how-it-works/join_our_network.svg',
        },
        {
          title: 'Get access to jobs',
          description:
            'We’ll showcase your profile to top companies, who already know your talents, and want to work with you.',
          icon: '/images/roles/how-it-works/get_access.svg',
        },
      ],
    };
  },
};
</script>

<style lang="scss" src="./HowItWorksSection.scss" scoped></style>
